<template>
    <div class="c-row lottery-usage-simple">
        <div class="c-tr">
            <div class="c-tw w-left">
                <div class="c-td is-1">
                    <div class="typo-label">Nazwa loterii</div>
                    <h3 class="c-promos-title h6">
                        {{ data.lottery.name }}
                    </h3>
                </div>
                <div class="c-td is-2">
                    <div class="typo-label">Nazwa sklepu / Adres</div>
                    <h3 class="c-promos-title h6">
                        {{ data.merchant.name }}
                    </h3>
                    {{ data.merchant.street }} {{ data.merchant.number }},
                    {{ data.merchant.postcode }} {{ data.merchant.city }},
                    {{ data.merchant.province }}
                </div>
            </div>
            <div class="c-tw w-right">
                <div class="c-td is-4">
                    <div class="typo-label">Liczba spalonych kodów</div>
                    {{ data.totalCodeUsages }}
                </div>
                <div class="c-td is-5">
                    <div class="typo-label">Kwota refundacji</div>
                    {{
                        isNaN(data.totalRefund)
                            ? data.totalRefund
                            : data.totalRefund.toFixed(2)
                    }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            showShops: false
        }
    },
    props: {
        data: {
            type: Object,
            required: true
        }
    },
    computed: {
        merchant() {
            return this.$store.getters.getMerchantById(this.data.merchantId)
        }
    }
}
</script>
